export const svgGradientFill = `url(#icon-gradient)`;
